/**
 * Fluid Grid Systems in JSS, Perdido, a translation of Lost.
 *
 * @copyright Wellington Cordeiro 2015
 * @website https://github.com/wldcordeiro/perdido
 * @license MIT
 */

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _perdido = require('./perdido');

var _perdido2 = _interopRequireDefault(_perdido);

exports['default'] = new _perdido2['default']();
module.exports = exports['default'];